<script lang="ts" setup>
  import { useShared } from '@othercommerce/foundation';
  import { computed } from 'vue';

  const shared = useShared();
  const name = computed(() => shared.value.appName || 'Promoznawcy');
</script>
<template>
  <main class="error-container container">
    <SfSection class="error-container__section">
      <SfLogo :aria-label="$t('SHOP.COMMON.ARIA.COMPANY_LOGO', { name })" class="error-container__logo" role="img" />
      <slot />
    </SfSection>
  </main>
</template>
<style lang="scss" scoped>
  @use "@storefront/styles/mixins/media";

  .error-container {
    display: flex;
    align-items: center;
    min-height: 100svh;
    --section-padding: 4rem 2rem;
    --section-content-gap: 3rem;

    &__section {
      align-items: center;

      :deep(.section__content) {
        align-items: center;
      }
    }

    &__logo {
      max-width: min(100%, 300px);
      max-height: 100px;
    }

    @include media.query(lg) {
      --section-padding: 3rem 0.625rem;
      --section-content-gap: 2rem;
    }
  }
</style>
